// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"ffe8f286","745":"e6c157a1","787":"68e28361","866":"6d0aab16","964":"fc567043"}[chunkId] + ".chunk.js";
};